import { Form, Formik } from 'formik';
import React, { Component } from 'react';
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import { userid } from '../../Common/Credentials.js';
import Footer from '../../Component/Footer.js';
import Header from '../../Component/Header.js';
import Menu from '../../Component/Menu.js';
import { FormikTextField } from '../../CommonComponents/FormField.js';
import { Spinner } from 'react-bootstrap';
import { Autocomplete } from '@mui/material';
import MasterService from '../MasterService.js';
import AutoCompeteField from '../../NewUI/NewComponents/AutoCompeteField.jsx';
import TextfieldComponent from '../../Component/TextfieldComponent.jsx';
import Breadcrumb from '../../NewUI/NewComponents/Breadcrumb.jsx';


class AddCity extends Component {
  constructor(props) {
    super(props)
    this.state = {
      city: '',
      message: '',
      countriesList: [],
      country: '',
      countryid: '',
      statesList: [],
      state: '',
      stateid: '',
      loader: false,
    }
    this.onSubmit = this.onSubmit.bind(this);
    this.validate = this.validate.bind(this);
  }

  onSubmit(values) {
    this.setState({ loader: true })
    let data = {
      name: this.state.city.toUpperCase(),
      state: this.state.stateid,
    }
    MasterService.AddCity(data).then(() =>
      this.props.navigate('/cities'))
      .catch((e) => {
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
        this.setState({ message: e.response.data.message, loader: false })
      })

  }

  handleCountryChange = (value, values) => {
    if (value !== undefined || value !== "") {
      this.setState({ country: value, countryid: values.id });
      MasterService.getStates(values.id).then(res => {
        this.setState({ statesList: res.data })
      })
    }
  };

  handleStateChange = (value, values) => {
    if (value !== undefined || value !== "") {
      this.setState({ state: values.name, stateid: values.id });
    }
  };

  componentDidMount() {

    if (userid === undefined) {
      window.confirm('Your Session is Lost: Please login Back to resume')
      this.props.navigate(`/`)
    }
    MasterService.getAllCountries().then(res => this.setState({ countriesList: res.data, loading: false }))

  }


  validate(values) {

    let errors = {}

    if (this.state.city === undefined || values.city === '') {
      errors.city = "City is Required";
    }
    if (this.state.state === undefined || this.state.state === '') {
      errors.state = "State is Required";
    }
    if (this.state.country === undefined || this.state.country === '') {
      errors.country = "Country is Required";
    }
    return errors;
  }

  render() {
    let { id, city, state, stateid, country, countryid } = this.state;

    return (

      <div>
        <Header />
        <Menu />
        <div className="content-wrapper">
        <div className="UI-container">
            <div className="UI-header">
          <Breadcrumb breadcrumbs={[{name:"Home",path:"/superadminmasters"},{name:"Cities",path:"/cities"},{name:"Add City",path:null}]}/>
          </div>
            <div className="UI-form-card">

              <Formik
                initialValues={{ id, city, state, stateid, country, countryid }}
                onSubmit={this.onSubmit}
                validateOnChange={false}
                validate={this.validate}
                enableReinitialize={true}>
                {({errors}) => (
                  <Form autoComplete="off">
                    <div className="form-row">
                      <fieldset className="col-md-3">
                      <AutoCompeteField label={"Country"} name={"country"} id="country" options={this.state.countriesList} value={this.state.country} onChange={this.handleCountryChange} labelKey={"name"} valueKey={"name"} error={errors?.country} required/>
                      </fieldset>
                      <fieldset className="col-md-3">
                      <AutoCompeteField label={"State"} name={"state"} id="state" options={this.state.statesList} value={this.state.state} onChange={this.handleStateChange} labelKey={"name"} valueKey={"name"} error={errors?.state} required/>
                      </fieldset>

                      <fieldset className="col-md-3">
                        <TextfieldComponent className="form-control" type="text" name="city" label="Enter City" onChange={(e) => this.setState({ city: e.target.value, message: '' })} error={errors?.city} required/>
                      </fieldset>
                    </div>
                    <div className="col-md-12 tw-my-2 text-red">{this.state.message}</div>
                    {this.state.loader === true ? <button className="UI-btn UI-btn-primary" disabled><Spinner animation="border" size="sm" />&nbsp;{"Saving"}</button> : <button className="UI-btn UI-btn-primary" type="submit">Save</button>}
                    <Link as="button" className="UI-btn UI-btn-outline ml-1 ml-1" to={{ pathname: '/city' }} >Cancel</Link>

                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}
export default withRouter(AddCity)